import React, { useState } from 'react';
import { motion } from 'framer-motion';
import {
  PageContainer,
  ContentGrid,
  Card,
  CardTitle,
  CardContent,
  ActionBar,
  Button,
  SearchInput,
  Table,
  TableHeader,
  TableRow,
  TableCell,
  StatusBadge,
  fadeIn,
  FilterBar,
  FilterButton
} from '../styles/PageStyles';
import PageHeaderWithInfo from '../components/common/PageHeaderWithInfo';
import { faLayerGroup } from '@fortawesome/free-solid-svg-icons';

const DocumentQueue = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [filter, setFilter] = useState('all');

  // Mock data for documents
  const documents = [
    { id: 'DOC-001', name: 'Insurance Policy.pdf', type: 'Policy', status: 'processed', confidence: 0.94, pages: 12, date: '2025-03-15' },
    { id: 'DOC-002', name: 'Medical Report.docx', type: 'Medical', status: 'processing', confidence: 0.78, pages: 8, date: '2025-03-17' },
    { id: 'DOC-003', name: 'Claim Form.pdf', type: 'Form', status: 'queued', confidence: 0, pages: 2, date: '2025-03-17' },
    { id: 'DOC-004', name: 'ID Verification.jpg', type: 'ID', status: 'processed', confidence: 0.92, pages: 1, date: '2025-03-16' },
    { id: 'DOC-005', name: 'Property Assessment.pdf', type: 'Assessment', status: 'review', confidence: 0.68, pages: 15, date: '2025-03-16' },
  ];

  // Filter documents based on search term and filter
  const filteredDocuments = documents.filter(doc => {
    const matchesSearch =
      doc.id.toLowerCase().includes(searchTerm.toLowerCase()) ||
      doc.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      doc.type.toLowerCase().includes(searchTerm.toLowerCase());

    if (filter === 'all') return matchesSearch;
    return matchesSearch && doc.status === filter;
  });

  // Get status badge color
  const getStatusColor = (status) => {
    switch (status) {
      case 'processed': return 'active';
      case 'processing': return 'warning';
      case 'queued': return 'default';
      case 'review': return 'error';
      default: return 'default';
    }
  };

  return (
    <PageContainer>
      <motion.div
        initial="hidden"
        animate="visible"
        variants={fadeIn}
      >
        <PageHeaderWithInfo
          icon={faLayerGroup}
          title="Document"
          description="AI-powered document processing system that automatically extracts, categorizes, and analyzes information from various document types,
          making the data available for downstream processes."
        >
          <div style={{ display: 'flex', gap: '1rem' }}>
            <SearchInput
              type="text"
              placeholder="Search Document..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />

            <Button primary>New Application</Button>
          </div>
        </PageHeaderWithInfo>
        <FilterBar>
          <FilterButton primary={filter === 'all'} onClick={() => setFilter('all')}>All Types</FilterButton>
          <FilterButton primary={filter === 'queued'} onClick={() => setFilter('queued')}>Queued</FilterButton>
          <FilterButton primary={filter === 'processing'} onClick={() => setFilter('processing')}>Processing</FilterButton>
          <FilterButton primary={filter === 'processed'} onClick={() => setFilter('processed')}>Processed</FilterButton>
          <FilterButton primary={filter === 'review'} onClick={() => setFilter('review')}>Needs Review</FilterButton>
        </FilterBar>
        {/* <ActionBar>

          <Button onClick={() => setFilter('all')} primary={filter === 'all'}>All</Button>
          <Button onClick={() => setFilter('queued')} primary={filter === 'queued'}>Queued</Button>
          <Button onClick={() => setFilter('processing')} primary={filter === 'processing'}>Processing</Button>
          <Button onClick={() => setFilter('processed')} primary={filter === 'processed'}>Processed</Button>
          <Button onClick={() => setFilter('review')} primary={filter === 'review'}>Needs Review</Button>
        </ActionBar> */}

        {/* <ContentGrid>
          <Card>
            <CardTitle>Processing Overview</CardTitle>
            <CardContent>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '1rem' }}>
                <div>
                  <div style={{ fontSize: '2rem', fontWeight: 'bold', color: 'var(--primary)' }}>87</div>
                  <div style={{ fontSize: '0.8rem', color: 'var(--text-secondary)' }}>Total Documents</div>
                </div>
                <div>
                  <div style={{ fontSize: '2rem', fontWeight: 'bold', color: '#8E8E93' }}>12</div>
                  <div style={{ fontSize: '0.8rem', color: 'var(--text-secondary)' }}>Queued</div>
                </div>
                <div>
                  <div style={{ fontSize: '2rem', fontWeight: 'bold', color: '#FFCC00' }}>15</div>
                  <div style={{ fontSize: '0.8rem', color: 'var(--text-secondary)' }}>Processing</div>
                </div>
                <div>
                  <div style={{ fontSize: '2rem', fontWeight: 'bold', color: '#34C759' }}>52</div>
                  <div style={{ fontSize: '0.8rem', color: 'var(--text-secondary)' }}>Processed</div>
                </div>
                <div>
                  <div style={{ fontSize: '2rem', fontWeight: 'bold', color: '#FF3B30' }}>8</div>
                  <div style={{ fontSize: '0.8rem', color: 'var(--text-secondary)' }}>Review</div>
                </div>
              </div>
            </CardContent>
          </Card>
          
          <Card>
            <CardTitle>Document Types</CardTitle>
            <CardContent>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '0.8rem' }}>
                <div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.3rem' }}>
                    <span>Policy Documents</span>
                    <span>32%</span>
                  </div>
                  <div style={{ width: '100%', height: '8px', background: 'rgba(0,102,255,0.1)', borderRadius: '4px' }}>
                    <div style={{ width: '32%', height: '8px', background: 'var(--primary)', borderRadius: '4px' }}></div>
                  </div>
                </div>
                
                <div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.3rem' }}>
                    <span>Medical Reports</span>
                    <span>24%</span>
                  </div>
                  <div style={{ width: '100%', height: '8px', background: 'rgba(0,102,255,0.1)', borderRadius: '4px' }}>
                    <div style={{ width: '24%', height: '8px', background: 'var(--primary)', borderRadius: '4px' }}></div>
                  </div>
                </div>
                
                <div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.3rem' }}>
                    <span>Forms</span>
                    <span>18%</span>
                  </div>
                  <div style={{ width: '100%', height: '8px', background: 'rgba(0,102,255,0.1)', borderRadius: '4px' }}>
                    <div style={{ width: '18%', height: '8px', background: 'var(--primary)', borderRadius: '4px' }}></div>
                  </div>
                </div>
                
                <div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.3rem' }}>
                    <span>ID Documents</span>
                    <span>15%</span>
                  </div>
                  <div style={{ width: '100%', height: '8px', background: 'rgba(0,102,255,0.1)', borderRadius: '4px' }}>
                    <div style={{ width: '15%', height: '8px', background: 'var(--primary)', borderRadius: '4px' }}></div>
                  </div>
                </div>
                
                <div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.3rem' }}>
                    <span>Other</span>
                    <span>11%</span>
                  </div>
                  <div style={{ width: '100%', height: '8px', background: 'rgba(0,102,255,0.1)', borderRadius: '4px' }}>
                    <div style={{ width: '11%', height: '8px', background: 'var(--primary)', borderRadius: '4px' }}></div>
                  </div>
                </div>
              </div>
            </CardContent>
          </Card>
        </ContentGrid> */}

        <Card
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2 }}
        >
          {/* <CardTitle>Document Queue</CardTitle> */}
          <Table>
            <thead>
              <tr>
                <TableHeader>Document ID</TableHeader>
                <TableHeader>Name</TableHeader>
                <TableHeader>Type</TableHeader>
                <TableHeader>Pages</TableHeader>
                <TableHeader>Date Added</TableHeader>
                <TableHeader>Confidence</TableHeader>
                <TableHeader>Status</TableHeader>
                <TableHeader>Actions</TableHeader>
              </tr>
            </thead>
            <tbody>
              {filteredDocuments.map(doc => (
                <TableRow key={doc.id}>
                  <TableCell>{doc.id}</TableCell>
                  <TableCell>{doc.name}</TableCell>
                  <TableCell>{doc.type}</TableCell>
                  <TableCell>{doc.pages}</TableCell>
                  <TableCell>{doc.date}</TableCell>
                  <TableCell>{doc.status === 'queued' ? '-' : `${(doc.confidence * 100).toFixed(0)}%`}</TableCell>
                  <TableCell>
                    <StatusBadge status={getStatusColor(doc.status)}>
                      {doc.status}
                    </StatusBadge>
                  </TableCell>
                  <TableCell>
                    <div style={{ display: 'flex', gap: '0.5rem' }}>
                      <Button style={{ padding: '0.3rem 0.6rem', fontSize: '0.8rem' }}>View</Button>
                      {doc.status === 'review' && (
                        <Button primary style={{ padding: '0.3rem 0.6rem', fontSize: '0.8rem' }}>Review</Button>
                      )}
                    </div>
                  </TableCell>
                </TableRow>
              ))}
            </tbody>
          </Table>
        </Card>
      </motion.div>
    </PageContainer>
  );
};

export default DocumentQueue;
